// extracted by mini-css-extract-plugin
export default {"change-host__title-step-text":"styles_change-host__title-step-text__XwZ4H"};